const permitir_informar_data_de_referencia_do_censo = [
  {
    path: "/permitir-informar-data-de-referencia-do-censo",
    name: "permitir_informar_data_de_referencia_do_censo",
    meta: {
      breadCrumb: "Censo Escolar - Data de Referência do Censo",
      allowedPermissions: ["referencia_data_censo_obter_por_ano"],
    },
    component: () =>
      import(
        "@/views/PermitirInformarDataDeReferenciaDoCenso/PermitirInformarDataDeReferenciaDoCenso.vue"
      ),
  },
];

export { permitir_informar_data_de_referencia_do_censo };
